import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import { useMutationWithError } from "../../../utils/hooks/useMutationWithError";
import {
  CreateSingleSlotBookingsInput,
  useCreateSingleSlotBookingsMutation,
} from "./__generated__/useCreateSingleSlotBookingsMutation.graphql";

const useCreateSingleSlotBookingsMutationString = graphql`
  mutation useCreateSingleSlotBookingsMutation(
    $input: CreateSingleSlotBookingsInput!
  ) {
    responsePayload: createSingleSlotBookings(input: $input) {
      errors {
        field
        code
        message
      }
      success
      startSlots {
        id
        ...TeeSheetAgendaConsistency_timeSlot
      }
      bookings {
        id
      }
    }
  }
`;

export const useCreateSingleSlotBookings = () => {
  const [createSingleSlotBookings, isCreating] =
    useMutationWithError<useCreateSingleSlotBookingsMutation>(
      useCreateSingleSlotBookingsMutationString
    );

  const { showToast } = useToast();

  const onCompletedErrorCustom = (errors: any) => {
    showToast({
      description: t`Sorry. An error occurred while creating your slot bookings.`,
      semanticStyle: "error",
      toastId: "create-single-slot-bookings-error",
    });

    return [];
  };

  const handleCreateSingleSlotBookings = (
    input: CreateSingleSlotBookingsInput,
    successCallback?: (bookingId: string) => void
  ) => {
    createSingleSlotBookings({
      variables: { input },
      onCompleted: (response) => {
        const data = response;
        if (data?.responsePayload?.success) {
          if (successCallback && data.responsePayload.bookings?.[0]?.id) {
            successCallback(data.responsePayload.bookings?.[0]?.id);
          }
        }
      },
      onCompletedErrorCustom: (errors: any) => onCompletedErrorCustom(errors),
    });
  };

  return [handleCreateSingleSlotBookings, isCreating] as const;
};
